export enum MedicalAttendanceTypeEnum {
	REQUESTED = 1,
	EVALUATED = 2,
}
